<div class="update-Coverage-dialog-content">
  <h4 class="modal-header">
    {{ headerMap[dialogData.action] }}
  </h4>
  @if (clientInfo$ | async; as clientInfo) {}
  <form [formGroup]="updateCoverageFormGroup" class="update-Coverage">
    <div class="form-wrapper" style="padding-bottom: 0">
      <div mat-row pad-b-1>
        @if (
          dialogData.action === "addCoverage" ||
          dialogData.action === "updateCoverage" ||
          dialogData.action === "addFutureCoverage" ||
          dialogData.action === "updateFutureCoverage"
        ) {
          <div class="mat-12">
            <mat-label>Group<span class="asterisk-mark">*</span></mat-label>
            <mat-form-field
              floatLabel="never"
              class="full-width mat-custom-select"
            >
              <mat-select
                placeholder="Select Group"
                formControlName="groupName"
                matNativeControl
                panelClass="custom-select-panel"
                [disableOptionCentering]="true"
              >
                <mat-option>
                  <ngx-mat-select-search
                    [formControl]="groupFilterControl"
                    [clearSearchInput]="true"
                    [showToggleAllCheckbox]="false"
                    placeholderLabel="Search Group(s) by ID or Name..."
                    noItemsLabel="No groups found"
                  >
                  </ngx-mat-select-search>
                </mat-option>
                @if ((filteredGroups | async)?.length === 0) {
                  <mat-option disabled> No Groups found </mat-option>
                }
                @if (filteredGroups | async; as groups) {
                  @for (group of groups; track group) {
                    <mat-option
                      class="grp-dropdown"
                      (click)="onGroupSelection(group)"
                      [value]="group.groupId"
                    >
                      {{ group.groupId }}: {{ group.groupName }}
                    </mat-option>
                  }
                }
              </mat-select>
            </mat-form-field>
            <app-custom-mat-hint
              [formGroup]="updateCoverageFormGroup"
              controlName="groupName"
            ></app-custom-mat-hint>
          </div>
        }
      </div>
      <div class="mat-row">
        @if (
          dialogData.action === "addRx" || dialogData.action === "updateRx"
        ) {
          <div class="mat-8 pad-r-2">
            <mat-label
              >Coverage Type<span class="asterisk-mark">*</span></mat-label
            >
            <mat-form-field
              floatLabel="never"
              class="full-width mat-custom-select"
            >
              <mat-select
                placeholder="Select Coverage Type"
                [disabled]="dialogData.action === 'updateRx'"
                (selectionChange)="onChangeFlag()"
                formControlName="groupName"
                matNativeControl
              >
                @for (type of dialogData.flexTagTypes; track type) {
                  <mat-option [value]="type.Tag">
                    {{ type.Name }}
                  </mat-option>
                }
                <!-- <mat-option value="FORCE65"> No Rx Coverage </mat-option>
                <mat-option value="WELLness">Wellness Program </mat-option>
                <mat-option value="PICA"> PICA Coverage </mat-option> -->
              </mat-select>
            </mat-form-field>
            <app-custom-mat-hint
              [formGroup]="updateCoverageFormGroup"
              controlName="groupName"
            ></app-custom-mat-hint>
          </div>
        }
        <div class="mat-6 pad-r-2">
          <mat-label
            >Effective Date<span class="asterisk-mark">*</span></mat-label
          >
          <div
            [ngClass]="{
              'disabled-date':
                dialogData.coverage.edit &&
                dialogData.action !== 'addRx' &&
                dialogData.action !== 'updateFutureCoverage',
            }"
          >
            <mat-form-field
              floatLabel="never"
              class="full-width mat-datepicker-alignment mat-custom-datepicker"
            >
              <input
                matInput
                [matDatepicker]="effectiveDatepicker"
                [min]="startDateMin"
                [max]="startDateMax"
                formControlName="startDate"
                appNumberOnly
                placeholder="Enter Effective Date (MM/DD/YYYY)"
                maxlength="10"
              />
              <mat-datepicker-toggle
                matIconSuffix
                [for]="effectiveDatepicker"
              ></mat-datepicker-toggle>
              <mat-datepicker #effectiveDatepicker></mat-datepicker>
            </mat-form-field>
            <app-custom-mat-hint
              [formGroup]="updateCoverageFormGroup"
              controlName="startDate"
            ></app-custom-mat-hint>
          </div>
        </div>
        <div class="mat-6">
          <mat-label
            >End Date
            @if (
              dialogData.action === "addRx" ||
              dialogData.action === "updateRx" ||
              dialogData.action === "updateCoverage" || 
              dialogData.action === "addCoverage" ||
              (dialogData.action === "addFutureCoverage" && dialogData.memberDetails.relationshipCode !== cardHolderRC) 
            ) {
              <span class="asterisk-mark">*</span>
            }</mat-label>
            <mat-form-field floatLabel="never" class="full-width mat-datepicker-alignment mat-custom-datepicker">
              <input matInput [matDatepicker]="endDatePicker" [min]="minDate" [max]="maxDate" appNumberOnly
                formControlName="endDate" placeholder="Enter End Date (MM/DD/YYYY)" maxlength="10" />
                <mat-datepicker-toggle matIconSuffix [for]="endDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #endDatePicker></mat-datepicker>
              </mat-form-field>
              <app-custom-mat-hint [formGroup]="updateCoverageFormGroup" [isCheckTouch]="false"
              controlName="endDate"></app-custom-mat-hint>
            </div>
          </div>
          @if (showCoverageNote) {
            <div class="coverage-validation-note">
              @switch (coverageNoteType) {
                @case (coverageNoteTypes.CardholderFuture) {
                  <p>
                    ** Please select future coverage dates that do not overlap with the cardholder’s active coverage.
                    Future coverage must start after
                   {{ getMinCoverageDate() | timeStampToDate }}.
                  </p>
                }
                @case (coverageNoteTypes.CardholderActiveAdd) {
                  <p>
                    ** Please select active coverage dates that do not overlap with the cardholder’s future coverage.
                    Active coverage must end before
                    {{ cardHoldersFutureCoverage?.startDate | timeStampToDate }}.
                  </p>
                }
                @case (coverageNoteTypes.CardholderActiveUpdate) {
                  <p>
                    ** Please select an active coverage end date that does not overlap with the cardholder’s future coverage.
                    Active coverage must end before
                    {{ cardHoldersFutureCoverage?.startDate | timeStampToDate }}.
                  </p>
                }
                @case (coverageNoteTypes.DependentFuture) {
                  <p>
                    ** Please choose dependent future coverage dates within the cardholder’s future coverage timeframe
                    {{ cardHoldersFutureCoverage?.startDate | timeStampToDate }} –
                    {{ cardHoldersFutureCoverage?.endDate | timeStampToDate }}.
                  </p>
                }
                @case (coverageNoteTypes.DependentActive) {
                  <p>
                    ** Please choose dependent active coverage dates within the cardholder’s active coverage timeframe
                    {{ cardHoldersCurrentCoverage?.startDate | timeStampToDate }} –
                    {{ cardHoldersCurrentCoverage?.endDate | timeStampToDate }}.
                  </p>
                }
                 @case (coverageNoteTypes.DependentFutureActive) {
                  <p>
                    ** Please choose dependent coverage dates within the cardholder’s current coverage timeframe
                    {{ cardHolderDetails?.coverage?.startDate | timeStampToDate }} –
                    {{ cardHolderDetails?.coverage?.endDate | timeStampToDate }}.
                  </p>
                }
                  @case (coverageNoteTypes.CardholderFutureActiveEdit) {
                  <p>
                    ** Please choose coverage dates that do not overlap with future coverage.
                    coverage must end before
                    {{ cardHoldersFutureCoverage?.startDate | timeStampToDate }}
                  </p>
                }
                  @case (coverageNoteTypes.cardHolderFutureActive) {
                  <p>
                  ** Please select future coverage dates that do not overlap with the active coverage.
                    Future coverage must start after
                    {{ dialogData?.memberDetails?.coverage?.endDate | timeStampToDate }}.
                  </p>
                }
              }
            </div>
          }
        </div>
    <!-- Note -->
    @if (
      dialogData.memberDetails.relationshipCode === cardHolderRC &&
      (dialogData.action === "updateCoverage" ||
        dialogData.action === "updateFutureCoverage" ||
        dialogData.action === "addCoverage" ||
        dialogData.action === "addFutureCoverage")
    ) {
      <div class="note-wrapper">
        <h3 class="total-dependents">Dependents ({{ totalDependents }})</h3>
        @if (dialogData.action === "updateCoverage") {
          <p class="coverage-note mt-2">
            The coverage end date will also be updated for the active
            dependents.
          </p>
        }
        @if (dialogData.action === "updateFutureCoverage") {
          <p class="coverage-note mt-2">
            The future coverage dates will also be updated for the all future
            covered dependents.
          </p>
        }
        @if (dialogData.action === "addCoverage") {
          <p class="coverage-note mt-2">
            The coverage will be added for the selected dependents.
          </p>
        }
        @if (dependents$ | async; as dependents) {
          <div class="content-table dependents-table">
            <table
              mat-table
              [dataSource]="dataSource"
              class="mat-elevation-z8 member-search-table update-coverage-dialog-table"
            >
              <ng-container matColumnDef="personCode">
                <th mat-header-cell *matHeaderCellDef width="70">
                  Person Code
                </th>
                <td mat-cell *matCellDef="let row">
                  <div
                    [ngClass]="{
                      'person-code-coverage-expired':
                        checkIfCoverageExpired(row),
                      'person-code-coverage-active':
                        checkIfCoverageIsStartingSoon(row),
                      'person-code-coverage-soft-deleted':
                        checkIfCoverageSoftDeleted(row),
                    }"
                  >
                    {{ row.personCode }}
                  </div>
                </td>
              </ng-container>
              @if (
                dialogData.action === "addCoverage" ||
                dialogData.action === "addFutureCoverage"
              ) {
                <ng-container matColumnDef="select">
                  <th mat-header-cell *matHeaderCellDef width="50"></th>
                  <td mat-cell *matCellDef="let row" class="checkbox">
                    <mat-checkbox (change)="selectRow(row)"></mat-checkbox>
                  </td>
                </ng-container>
              }
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef>Name</th>
                <td mat-cell *matCellDef="let row">
                  {{ row.firstName }} {{ row.lastName }}
                </td>
              </ng-container>
              <ng-container matColumnDef="cardId">
                <th mat-header-cell *matHeaderCellDef>Card/Alt ID</th>
                <td mat-cell *matCellDef="let row">
                  {{ row.cardId }}
                </td>
              </ng-container>
              <!-- <ng-container matColumnDef="personCode">
                  <th mat-header-cell *matHeaderCellDef>Person Code</th>
                  <td mat-cell *matCellDef="let row">
                    {{ row.personCode }}
                  </td>
                </ng-container> -->
              <ng-container matColumnDef="relationshipCode">
                <th mat-header-cell *matHeaderCellDef>Relationship</th>
                <td mat-cell *matCellDef="let row">
                  {{ row.relationshipCode }} - {{ row.relationshipValue }}
                </td>
              </ng-container>
              <ng-container matColumnDef="gender">
                <th mat-header-cell *matHeaderCellDef>Gender</th>
                <td mat-cell *matCellDef="let row">
                  {{ displayGender[row.gender] }}
                </td>
              </ng-container>
              <ng-container matColumnDef="DOB">
                <th mat-header-cell *matHeaderCellDef>DOB</th>
                <td mat-cell *matCellDef="let row">
                  {{ row.DOB | timeStampToDate }}
                </td>
              </ng-container>
              <ng-container matColumnDef="startDate">
                <th mat-header-cell *matHeaderCellDef>Effective Date</th>
                <td mat-cell *matCellDef="let row">
                  {{ row.coverage.startDate | timeStampToDate }}
                </td>
              </ng-container>
              <ng-container matColumnDef="endDate">
                <th mat-header-cell *matHeaderCellDef>End Date</th>
                <td mat-cell *matCellDef="let row">
                  {{ row.coverage.endDate | timeStampToDate }}
                </td>
              </ng-container>
              <tr
                mat-header-row
                *matHeaderRowDef="displayedColumns; sticky: true"
              ></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: displayedColumns"
                [ngClass]="{
                  'coverage-expired-active': checkIfCoverageExpired(row),
                }"
              ></tr>
              <tr class="mat-row no-data-row" *matNoDataRow>
                <td class="mat-cell" colspan="8" role="status">
                  No Data Found
                </td>
              </tr>
            </table>
          </div>
        }
        <div class="coverage-expired accordion-table-footer">
          <div class="legends mt-2">
            <div class="legends-item">
              <span class="cs-legend"></span>
              Coverage Starting Soon
            </div>
            <div class="legends-item">
              <span class="ce-legend"></span>
              Coverage Expired
            </div>
            <div class="legends-item">
              <span class="cd-legend"></span>
              Soft Deleted
            </div>
          </div>
        </div>
      </div>
    }
    <div class="mat-row dialog-btn-row">
      <div class="mat-12" fxLayoutAlign="end end">
        @if (
          dialogData.action !== "addRx" && dialogData.action !== "updateRx"
        ) {
          <button
            mat-button
            class="primary-btn"
            [disabled]="
              !checkIfAnythingUpdated() ||
              updateCoverageFormGroup.invalid ||
              isSaving
            "
            (click)="save()"
          >
            Save Changes
          </button>
        }
        @if (
          dialogData.action === "addRx" || dialogData.action === "updateRx"
        ) {
          <button
            mat-button
            class="primary-btn"
            [disabled]="
              !checkIfAnythingUpdated() ||
              updateCoverageFormGroup.invalid ||
              isSaving
            "
            (click)="save()"
          >
            Save Changes
          </button>
        }
        <button mat-button class="secondary-btn" (click)="cancel()">
          Cancel
        </button>
      </div>
    </div>
  </form>
</div>
